module.exports = "/images/milano-15.jpg";